//
import { RFormFields } from '@/components/reusable_components/next'
import ProviderModel from '@/models/Purchase/PchProvider'

//
export default RFormFields
  .from([
    {
      name: 'pch_provider_id',
      type: 'autocomplete-model',
      props: {
        itemText: 'alias_name',
        itemValue: 'id',
        label: 'Proveedor',
        model: ProviderModel,
        noDataText: 'Sin proveedores.',
        noObject: true,
      },
    },
  ])
